import React, { useState } from "react";
import { Box, TextField, MenuItem, Typography } from "@mui/material";
// import Iconify from "../../Iconify";
import { useFurnitureStore } from "../../../contexts/SelectedVariantContext";
import {finishesById} from "../../../utils/colors";

const sedutaImages = [
    // {
    //     id: "aperto",
    //     url: "https://dominoflowerbox.com/wp-content/uploads/2024/07/8-SEDUTA-CON-VANO-CONTENITORE_aperto_R04-1536x864.jpg",
    //     alt: "Seduta con vano contenitore - Aperto",
    // },
    // {
    //     id: "chiuso",
    //     url: "https://dominoflowerbox.com/wp-content/uploads/2024/07/8-SEDUTA-CON-VANO-CONTENITORE_chiuso_R04-1536x864.jpg",
    //     alt: "Seduta con vano contenitore - Chiuso",
    // },
];

const sedutaFinishIds = ["ral_9006", "ral_custom"];

export default function SedutaFinishesSelector() {
    const { selectedVariant, setSelectedVariant } = useFurnitureStore();
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () =>
        setCurrentIndex((prev) => (prev + 1) % sedutaImages.length);
    const handlePrev = () =>
        setCurrentIndex((prev) => (prev - 1 + sedutaImages.length) % sedutaImages.length);

    const handleFinishChange = (finishId) => {
        setSelectedVariant({
            ...selectedVariant,
            colorId: finishId,
        });
    };

    return (
        <Box sx={{ my: 2 }}>
            <Typography variant="h6" gutterBottom>
                Seleziona finitura/colore
            </Typography>

            {/*<Box sx={{ position: "relative", textAlign: "center" }}>*/}
            {/*    <img*/}
            {/*        src={sedutaImages[currentIndex].url}*/}
            {/*        alt={sedutaImages[currentIndex].alt}*/}
            {/*        style={{*/}
            {/*            width: "100%",*/}
            {/*            maxHeight: 300,*/}
            {/*            objectFit: "cover",*/}
            {/*            borderRadius: 8,*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            position: "absolute",*/}
            {/*            top: "50%",*/}
            {/*            left: 0,*/}
            {/*            transform: "translateY(-50%)",*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <IconButton onClick={handlePrev}>*/}
            {/*            <Iconify icon="eva:arrow-back-fill" width={24} height={24} />*/}
            {/*        </IconButton>*/}
            {/*    </Box>*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            position: "absolute",*/}
            {/*            top: "50%",*/}
            {/*            right: 0,*/}
            {/*            transform: "translateY(-50%)",*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <IconButton onClick={handleNext}>*/}
            {/*            <Iconify icon="eva:arrow-forward-fill" width={24} height={24} />*/}
            {/*        </IconButton>*/}
            {/*    </Box>*/}
            {/*</Box>*/}

            {/*<Box sx={{ mt: 1, display: "flex", justifyContent: "center", gap: 1 }}>*/}
            {/*    {sedutaImages.map((_, idx) => (*/}
            {/*        <Box*/}
            {/*            key={idx}*/}
            {/*            sx={{*/}
            {/*                width: 10,*/}
            {/*                height: 10,*/}
            {/*                borderRadius: "50%",*/}
            {/*                backgroundColor:*/}
            {/*                    idx === currentIndex ? "primary.main" : "grey.400",*/}
            {/*            }}*/}
            {/*        />*/}
            {/*    ))}*/}
            {/*</Box>*/}

            <Box sx={{ mt: 2 }}>
                <TextField
                    select
                    fullWidth
                    value={selectedVariant.colorId || ""}
                    onChange={(e) => handleFinishChange(e.target.value)}
                    label="Seleziona finitura/colore"
                >
                    {sedutaFinishIds.map((id) => (
                        <MenuItem key={id} value={id}>
                            {finishesById[id]?.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
        </Box>
    );
}
